var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsArrowBackIosNewRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2166 19.6834L7.22812 12.591C7.14517 12.5066 7.08628 12.4151 7.05144 12.3166C7.0166 12.2181 6.99946 12.1126 7.00001 12C7.00001 11.8874 7.01716 11.7819 7.05144 11.6834C7.08573 11.5849 7.14462 11.4934 7.22812 11.409L14.2166 4.29551C14.4101 4.0985 14.6521 4 14.9424 4C15.2327 4 15.4816 4.10554 15.6889 4.31662C15.8963 4.5277 16 4.77397 16 5.05541C16 5.33685 15.8963 5.58311 15.6889 5.7942L9.59218 12L15.6889 18.2058C15.8825 18.4028 15.9793 18.6457 15.9793 18.9345C15.9793 19.2232 15.8756 19.4729 15.6682 19.6834C15.4608 19.8945 15.2189 20 14.9424 20C14.6659 20 14.424 19.8945 14.2166 19.6834Z",
    fill: "#E9FE53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#E9FE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsArrowBackIosNewRounded);
export default __webpack_public_path__ + "static/media/material-symbols_arrow-back-ios-new-rounded.970194f7ee06274ba3ef388bcb26327a.svg";
export { ForwardRef as ReactComponent };